import { z } from 'zod';
import { Url } from '../../utils/codecUtils';
import { reautomatePayloadSchema } from './reautomate.schema';

export type ReautomatePayload = {
  annotations: Array<Url>;
  ifModified?: 'skip' | 'tryToConfirm';
};

export type ReautomateResponse = {
  annotations: Array<Url>;
};

export const reautomate = (payload: ReautomatePayload) => {
  return {
    endpoint: `/internal/annotations/reautomate`,
    method: 'POST',
    payload,
    payloadSchema: reautomatePayloadSchema,
    responseSchema: z.object({ annotations: z.array(z.string()) }),
  } as const;
};
